<template>
  <div>
    <slot name="prefixo">
      <label v-if="prefixo.length">{{ prefixo }}</label>
    </slot>
    <input
      v-bind="$attrs"
      type="text"
      ref="inputFormatadorRef"
      v-bind:value="formatar(valor)"
      v-on="inputListeners"
      @keyup="$event.target.value = validaCaracteres($event)"
      @blur="$event.target.value = removerCasasIrrelevantes($event.target.value)"
      @change="forcarAtualizacaoInput"
      :class="classesCss"
      :disabled="disabled"
    />
    <slot name="sufixo">
      <label v-if="sufixo.length">{{ sufixo }}</label>
    </slot>
  </div>
</template>
<script>

export default {
  inheritAttrs: false,
  name: 'SysInputFormatadorDeValor',
  model: {
    prop: 'valor',
    event: 'input'
  },
  props: {
    valor: {
      require: false
    },
    prefixo: {
      type: String,
      default: ''
    },
    sufixo: {
      type: String,
      default: ''
    },
    maxDigitos: {
      type: Number,
      default: 4
    },
    inteiro: {
      type: Boolean,
      default: false
    },
    centralizar: {
      type: Boolean,
      require: false
    },
    removerValorIrrelevante: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      init: true
    }
  },
  computed: {
    inputListeners: function () {
      var vm = this

      return Object.assign({},
        this.$listeners,
        {
          input: function (event) {
            const { value } = event.target

            const valorSemMascara = vm.removeMascara(value)

            vm.$emit('input', parseFloat(valorSemMascara))
          }
        }
      )
    },
    classesCss () {
      let classes = ''
      if (this.centralizar) classes += 'centralizado'

      return classes
    }
  },
  methods: {
    forcarAtualizacaoInput(e) {
      const { value } = e.target;
      const valorSemMascara = this.removeMascara(value);
      this.$emit('forcar-atualizacao-input', parseFloat(valorSemMascara));
    },
    formatar (value) {
      if (!value) return 0

      if (this.init && this.removerValorIrrelevante) {
        value = parseFloat(value)
      }

      let qtdeCasasDecimais = this.getQtdeCasasDecimais(value)

      if (qtdeCasasDecimais > this.maxDigitos && !this.inteiro) {
        qtdeCasasDecimais = this.maxDigitos
      }

      if (this.inteiro) {
        qtdeCasasDecimais = 0
      }

      const FORMATO = {
        style: "decimal",
        maximumFractionDigits: qtdeCasasDecimais,
        minimumFractionDigits: qtdeCasasDecimais
      }

      return new Intl
        .NumberFormat('pt-BR', FORMATO)
        .format(value);
    },
    getQtdeCasasDecimais (valor) {
      const indexPontoDecimal = ''.concat(valor).indexOf('.')

      if (indexPontoDecimal === -1) return 0

      return ''
        .concat(valor)
        .substring(indexPontoDecimal + 1)
        .length
    },
    removeMascara (valor) {
      return ''
        .concat(valor)
        .replace(/[.]/g, '')
        .replace(/[,]/g, '.')
    },
    validaCaracteres (event) {
      let removerCaracteres = /[a-zA-Z]/g

      if (this.inteiro) removerCaracteres = /[a-zA-Z,]/g

      return ''.concat(event.target.value)
        .replace(removerCaracteres, '')
        .replace(/,,/g, '')
    },
    removerCasasIrrelevantes (value) {
      if (!this.removerValorIrrelevante) return value

      if (this.init) this.init = false

      const VALOR_SEM_MASCARA = this.removeMascara(value)
      const VALOR_FLOAT = parseFloat(VALOR_SEM_MASCARA)

      return this.formatar(VALOR_FLOAT)
    },
    focus() {
      this.$refs.inputFormatadorRef.focus();
    }
  }
}
</script>

<style lang="css" scoped>
div {
  display:flex;
  flex-direction: row;
  justify-content: center;
  align-items: center
}
input {
  position: relative;
  outline: none;
  width: 100%;
  margin: 0;
  padding: 0;
}
label {
  padding-right: 4px;
}
.centralizado {
  text-align: center;
}
</style>
